import { css } from 'styled-components';

export const globalStyle = css`
    html,
    body,
    #root {
        width: 100%;
        height: 100%;
        overflow: auto;
        position: relative;
        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        color: #fff;
    }

    .root svg {
        fill: currentColor;
    }

    html {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
    }

    body {
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-tap-highlight-color: transparent;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
        font-family: inherit;
    }

    input,
    input:before,
    input:after,
    textarea,
    textarea:before,
    textarea:after {
        user-select: initial;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type='number'] {
        -moz-appearance: textfield;
    }

    input:focus {
        outline: none;
    }

    input::-moz-focus-inner {
        border: 0;
    }

    a {
        text-decoration: none;
    }

    select,
    input {
        border: none;
        box-sizing: border-box;
    }

    button {
        border: none;
        outline: none;
    }
`;

export default globalStyle;
